import { reactive, toRefs, ref } from 'vue'
import apiRole from '../api/role.api'

const state = reactive({
  roleList: [],
  filterOptions: {},
  loading: false,
  pagination: ref({
    page: 1,
    rowsPerPage: 20,
    rowsNumber: 0
  }),
  paginationInfoLoading: false
})

const getSummary = async (params) => {
  state.paginationInfoLoading = true

  try {
    const { data: { total } } = await apiRole.getTotal(params)

    state.pagination.rowsNumber = total
  } catch {
  } finally {
    state.paginationInfoLoading = false
  }
}

export default function useRole() {

  const getRoleList = async (params) => {
    state.loading = true
    getSummary(params)
    const { data } = await apiRole.getList(params)
    state.roleList = Object.freeze(data)
    state.filterOptions = params

    state.pagination.page = params?.page ? params.page : 1
    state.pagination.rowsPerPage = params["page-size"] ? params["page-size"] : 20

    state.loading = false
  }

  return {
    ...toRefs(state),
    getRoleList
  }
}